import { useEffect, useCallback, useRef } from "react";
import { Socket } from "socket.io-client";
import { websocketService } from "../services/websocket.service";

export const useWebSocket = () => {
    const connectionCountRef = useRef(0);

    useEffect(() => {
        // Only connect if this is the first instance of the hook
        if (connectionCountRef.current === 0) {
            websocketService.connect();
        }
        connectionCountRef.current += 1;

        // Cleanup on unmount
        return () => {
            connectionCountRef.current -= 1;
            // Only disconnect if this is the last instance of the hook
            if (connectionCountRef.current === 0) {
                websocketService.disconnect();
            }
        };
    }, []);

    const sendMessage = useCallback((message: { type: string; data: unknown }) => {
        websocketService.sendMessage(message);
    }, []);

    const getSocket = useCallback((): Socket | null => {
        return websocketService.getSocket();
    }, []);

    const isConnected = useCallback((): boolean => {
        return websocketService.isConnected();
    }, []);

    return {
        sendMessage,
        getSocket,
        isConnected,
    };
};
